module.exports = __webpack_public_path__ + "static/43-32710452e04ff30b2c7d29678180bfd2.png";